import React from 'react';
import { useTranslation } from 'react-i18next';
import { personenAutoStyles as styles } from '../../../styles/commonStyles';

export const ValidationSummary: React.FC<{ validationErrors: Record<string, string> }> = ({ validationErrors }) => {
  const { t } = useTranslation();

            const fieldLabelMap: Record<string, string> = {
              'BA_PCODE': t('screens.aansprakelijkheid.fields.postalCode'),
              'BA_HUISNR': t('screens.aansprakelijkheid.fields.houseNumber'),
              '_addressValidation': t('screens.personenauto.sections.address', 'Adres'),
              'OB_KENTEKE': t('screens.personenauto.fields.licensePlate'),
              'OB_AFMKM': t('screens.personenauto.fields.annualMileage'),
              'PP_SCHDVRY': t('screens.personenauto.fields.noClaimsYears'),
              'OB_AANKDAT': t('screens.personenauto.fields.purchaseDate', 'Aankoopdatum'),
              '_eersteEigenaar': t('screens.personenauto.fields.firstOwner', 'Huidige eigenaar is tevens eerste eigenaar'),
              'OB_TNOKLAS': t('screens.personenauto.fields.securityClass'),
              'BS_RELSRTC': t('screens.personenauto.fields.driverRelation', 'Relatie tot verzekeringnemer'),
              'BS_VOORL': t('form.initials', 'Voorletters'),
              'BS_ANAAM': t('form.lastName', 'Achternaam'),
              'BS_GESLACH': t('form.gender', 'Geslacht'),
              'BS_GEBDAT': t('form.dateOfBirth', 'Geboortedatum'),
              '_kwValidation': t('screens.personenauto.fields.kilowatt'),
            };
            const keys = Object.keys(validationErrors);
            if (keys.length === 0) return null;
            return (
              <div style={styles.calcErrorBanner}>
                <svg style={styles.errorIcon20Top} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <div style={styles.flex1}>
                  <div>{t('screens.personenauto.validation.bannerTitle')}</div>
                  <ul style={styles.helperListItem}>
                    {Array.from(new Set(keys.map((key) => fieldLabelMap[key] || t(validationErrors[key])))).map((label) => (
                      <li key={label}>{label}</li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          };
